module.exports = __webpack_public_path__ + "img/redshift.ca7f4527.jpg";